import Component from "../../component.abstract";

export default abstract class ValidatedGroup extends Component {
    protected requiredMessage = "Veuillez cocher une option";
    protected errorMessage: HTMLSpanElement;
    protected valid: boolean;
    protected inputsArray: Array<HTMLInputElement>;

    constructor(props: any, element: HTMLInputElement) {
        super(props, element);
        this.valid = false;
    }

    abstract mounted(): void;

    /**
    * Check for input group.
    * Need at least one input checked for validate 
    * May change if we need to check to different case
    */
    check(): boolean {
        this.valid = this.inputsArray.some(input => input.checked)

        this.displayErrors();

        return this.valid;
    }

    abstract displayErrors(): void;

    isValid(): boolean {
        return this.valid;
    }
}
